import { Button, Flex } from 'antd'
import type { NiiReportFields } from 'features/libra/stepComponents/niiReport/niiReportApi'
import { FileText } from 'lucide-react'
import { FC, memo } from 'react'
import styled from 'styled-components'
import cantileverTheme from 'styles/cantileverTheme'

import { useNiiPdfExport } from './NiiPdfExportHooks'

const PrimaryButton = styled(Button)`
  && {
    background-color: ${cantileverTheme.colors.OceanBlue};
    border-color: ${cantileverTheme.colors.OceanBlue};
  }
`

interface NiiPdfExportButtonProps {
  fields: NiiReportFields
  zoneFieldName?: string
}

const RawNiiPdfExportButton: FC<NiiPdfExportButtonProps> = ({
  fields,
  zoneFieldName,
}) => {
  const { handleGenerateAndDownload, isGenerating } = useNiiPdfExport(
    fields,
    zoneFieldName
  )

  return (
    <Flex justify='flex-end'>
      <PrimaryButton
        type='primary'
        icon={<FileText size={14} />}
        loading={isGenerating}
        onClick={handleGenerateAndDownload}>
        Download report
      </PrimaryButton>
    </Flex>
  )
}

export const NiiPdfExportButton = memo(RawNiiPdfExportButton)
